import { environment } from '../../environments/environment';

const apiUrl = environment.urls.apiUrl;
const dictionaryApiUrl = environment.urls.dictionaryApiUrl;
const gatewayCommonServicesApiUrl = '/api-gateway/common-services';
const gatewayDictionaryApiUrl = '/api-gateway/dictionary';
const userSecurityServiceBaseUrl = '/user-security-service/api/v1';
const commonServicesBaseUrl = '/common-services/api/v1';
const notificationsApiUrl = '/supplier/lk/api/notifications/';
/** Хранит адреса методов API */
export class AppUrls {
  /** Ссылки на авторизацию */
  public static auth = {
    participantLogOutUrl: '/auth/sso/logout/participant',
    customerLogOutUrl: '/auth/sso/logout/customer',
    logInUrl: '/auth/sso/login/participant',
    customerLogInUrl: '/auth/sso/login/customer',
    renewParticipantSecurityTokenUrl: '/supplier/lk/api/security/token/renew',
    renewCustomerSecurityTokenUrl: '/customer/lk/api/security/token/renew',
  };

  /** Ссылки на авторизацию */
  public static captcha = {
    settings: 'api/captcha/humanometr/settings',
  };

  /**Ссылки для работы с заказчиком */
  public static customerUrls = {
    drugs: {
      getPositionById: `${apiUrl}customer/offer-drug-item-registry/`,
      getPositionsList: `${apiUrl}customer/offer-drug-item-registry/search/elastic`,
      getTotalCount: `${apiUrl}customer/offer-drug-item-registry/search/elastic/count`,
      getSuppliers: `${apiUrl}customer/offer-drug-item-registry/participants/search`,
    },
    searchElasticUrl: `${apiUrl}CustomerRegistry/pricelistitem/search/elastic`,
    file: `${apiUrl}File/`,
    signatureInfo: '/signature/info',
    searchKtru: `${dictionaryApiUrl}Ktru/search/by-string`,
    searchDeliveryPlaces: `${dictionaryApiUrl}Ktru/search/by-string`,
    filterTotalCount: `${apiUrl}CustomerRegistry/pricelistitem/count`,
    excelBuild: `${apiUrl}CustomerRegistry/price-list-item/excel/build`,
    eisExcelBuild: `${apiUrl}OfferPriceListItem/{0}/{1}/excel/build`,
    suppliersSearch: `${apiUrl}CustomerRegistry/participants/search`,
    suitableOffers: `${apiUrl}offer-item-comparison/compare`,
    suitableDrugOffers: `${apiUrl}offer-item-comparison/drugs/compare`,
    compareExcelBuild: `${apiUrl}offer-item-comparison/excel/build`,
  };

  public static sharedUrls = {
    userInfo: `${apiUrl}User`,
  };

  public static rejection = {
    getCount: `/api-gateway/tender/applications/organization/current/rejection-for-shirker/count`,
  };

  public static errorUrls = {
    forbiddenPage: `/forbidden`,
  };

  /** Ссылки для работы с прайс-листами */
  public static priceLists = {
    create: `${apiUrl}PriceList`,
    search: `${apiUrl}PriceList/search`,
  };

  public static priceListItem = {
    createUrl: `${apiUrl}PriceListItem`,
    searchUrl: `${apiUrl}PriceListItem/search`,
    searchElasticUrl: `${apiUrl}PriceListItem/search/elastic`,
    searchElasticSupplierUrl: `${apiUrl}supplier/price-list-items/search`,
    getItemByIdUrl: `${apiUrl}PriceListItem/`,
    edit: '/supplier/price-lists/positions/edit/{0}',
    info: `${apiUrl}PriceListItemInfo`,
  };

  public static fileUrls = {
    uploadFileUrl: `${apiUrl}File/upload`,
    downloadFileUrl: `${apiUrl}File/download/{0}`,
    fileInfo: `${apiUrl}File/info/{0}`,
    xlstemplate: `${apiUrl}Templates/{0}`,
  };

  public static gatewayCommonServicesUrls = {
    oktmosAutocomplete: `${gatewayCommonServicesApiUrl}/dictionary/oktmo/oktmos/short/search`,
  }

  public static gatewayDictionaryUrls = {
    getMnnAutocomplete: `${gatewayDictionaryApiUrl}/drugs/mnn/distinct/search`,
    getMedicamentalFormAutocomplete: `${gatewayDictionaryApiUrl}/drugs/medicamental-form/distinct-by-mnn/search?mnnName={0}`,
    getGrlsValueAutocomplete: `${gatewayDictionaryApiUrl}/drugs/grls/distinct-by-mnn/search?mnnName={0}`,
    getDosageOkeiAutocomplete: `${gatewayDictionaryApiUrl}/drugs/okei-dosage/distinct-by-mnn/search?mnnName={0}`,
    getTradeNameAutocomplete: `${gatewayDictionaryApiUrl}/drugs/trade-names/distinct/search`,
    getCertificateNumberAutocomplete: `${gatewayDictionaryApiUrl}/drugs/certificate-numbers/distinct/search`,
    getDrugCodeAutocomplete: `${gatewayDictionaryApiUrl}/drugs/codes/distinct/search`,
    getCertificateKeeperNameAutocomplete: `${gatewayDictionaryApiUrl}/drugs/certificate-keeper/distinct/search`,
    getManufacturerNameAutocomplete: `${gatewayDictionaryApiUrl}/drugs/manufacturer/distinct/search`,
    getPrimaryPackagingNameAutocomplete: `${gatewayDictionaryApiUrl}/drugs/primary-packaging/distinct/search`,
    getPackaging1QuantityAutocomplete: `${gatewayDictionaryApiUrl}/drugs/packaging1-quantity/distinct/search`,
    getPackaging2QuantityAutocomplete: `${gatewayDictionaryApiUrl}/drugs/packaging2-quantity/distinct/search`,
    getConsumerTotalAutocomplete: `${gatewayDictionaryApiUrl}/drugs/consumer-total/distinct/search`,
    mnn: `${gatewayDictionaryApiUrl}/drugs/mnn/search`,
    trade: `${gatewayDictionaryApiUrl}/drugs/trade-names/search`,
  };

  public static dictionaryUrls = {
    code: `${dictionaryApiUrl}Ktru/code?ktruCode={0}`,
    searchKtru: `${dictionaryApiUrl}Ktru/search`,
    shortSearchKtru: `${dictionaryApiUrl}Ktru/short-search`,
    searchKtruByCodeOrName: `${dictionaryApiUrl}Oktmo/start-with-partialCodeName?partialCodeName={0}&skip={1}&take={2}`,
    searchKtruByCode: `${dictionaryApiUrl}Ktru/search/by-code?partialCode={0}`,
    searchKtruByName: `${dictionaryApiUrl}Ktru/search/by-name?partialName={0}`,
    countries: `${dictionaryApiUrl}Country`,
    nds: `${dictionaryApiUrl}NsiVatType/by-filter`,
    okeis: `${dictionaryApiUrl}Okei/all/short`,
    oktmo: `${dictionaryApiUrl}Oktmo/search/byCode?oktmoCode={0}`,
    oktmoFilter: `${dictionaryApiUrl}Oktmo/by-filter`,
    oktmoHierarchy: `${dictionaryApiUrl}Oktmo/hierarchy?code={0}`,
    oktomCodes: `${dictionaryApiUrl}Oktmo/codes`,
    kladrCodes: `${dictionaryApiUrl}Kladr/codes`,
    dublicateKtru: `${apiUrl}OfferPriceListItem/duplicate/exist`,
    bik: `${dictionaryApiUrl}Bank/search/by-bik-name?query={0}`,
    registryNumbers: dictionaryApiUrl,
    getChangeReasons: `${dictionaryApiUrl}Drug/change-reason/by-filter`,
  };

  public static participantUrls = {
    info: `${apiUrl}Participant`,
    saveDocument: `${apiUrl}Participant/document`,
    removeDocument: `${apiUrl}Participant/document`,
    searchDocuments: `${apiUrl}Participant/document/search`,
    generateDeclaration: `${apiUrl}Participant/declaration/matchunifiedrequirements/generate`,
    getDeclaration: `${apiUrl}Participant/declaration/matchunifiedrequirements/htmlContent?participantDocumentId=`,
    setDocumentsAsDefaultUrl: `${apiUrl}Participant/document/set-default`,
    resetDocumentsAsDefaultUrl: `${apiUrl}Participant/document/reset-default`,
    getDefaulDocumentsUrl: `${apiUrl}Participant/documents/default`,
  };

  public static participaintUrls = {
    importExcel: `${apiUrl}Participaint/import/excel`,
    importYml: `${apiUrl}Participaint/import/yml`,
    search: `${apiUrl}Participaint/import/search`,
    errors: `${apiUrl}Participaint/import/errors/{0}`,
  };

  public static offerUrls = {
    save: `${apiUrl}Offer`,
    get: `${apiUrl}Offer/{0}`,
    prepareForPublish: `${apiUrl}Offer/prepareforpublish`,
    publish: `${apiUrl}Offer/publish`,
    withdraw: `${apiUrl}Offer/withdraw`,
    printForm: `${apiUrl}Offer/printform`,
    prolongate: `${apiUrl}Offer/prolongate`,
    findOffer: `${apiUrl}CustomerRegistry/offer-items/find`,
  };

  public static offerPriceListItem = {
    save: `${apiUrl}OfferPriceListItem/temporary/create`,
    prepareForPublish: `${apiUrl}OfferPriceListItem/prepareforpublish`,
    publish: `${apiUrl}OfferPriceListItem/publish`,
    getById: `${apiUrl}OfferPriceListItem/`,
    info: `${apiUrl}PriceListItemInfo/`,
    delete: `${apiUrl}OfferPriceListItem`,
    nationalMode: `${apiUrl}OfferPriceListItem/national-mode/info-types/?okpd2Code={0}`,
    createDraft: `${apiUrl}OfferPriceListItem/draft/create`,
    updateDraft: `${apiUrl}OfferPriceListItem/draft/update`,
    saveDraftFromPublished: `${apiUrl}OfferPriceListItem/draft/from-published`,
    deleteDraft: `${apiUrl}OfferPriceListItem/draft/{0}`,
  };

  public static drugPriceListItem = {
    save: `${apiUrl}offer-price-list-drug-item/temporary/create`,
    generatePrintForm: `${apiUrl}offer-price-list-drug-item/print-form/generate`,
    getDataForSign: `${apiUrl}offer-price-list-drug-item/data-for-sign`,
    publish: `${apiUrl}offer-price-list-drug-item/publish`,
    deletePosition: `${apiUrl}offer-price-list-drug-item/{0}`,
    deleteDraft: `${apiUrl}offer-price-list-drug-item/draft/{0}`,
    getById: `${apiUrl}offer-price-list-drug-item/`,
    createDraft: `${apiUrl}offer-price-list-drug-item/draft/create`,
    updateDraft: `${apiUrl}offer-price-list-drug-item/draft/update`,
    saveDraftFromPublished: `${apiUrl}offer-price-list-drug-item/draft/from-published`,
    getNationalModeInfoTypes: `${apiUrl}offer-price-list-drug-item/national-mode/info-types/?mnnExternalCode={0}`,
    checkDuplicate: `${apiUrl}offer-price-list-drug-item/duplicate/exist`,
    searchDeliveries: `${apiUrl}offer-price-list-drug-item/deliveries/search`,
  };

  public static offerInfoUrls = {
    getCurrentOffer: `${apiUrl}OfferInfo/active`,
    saveOffer: `${apiUrl}OfferInfo`,
    prepareForPublish: `${apiUrl}OfferInfo/prepareforpublish`,
    publish: `${apiUrl}OfferInfo/publish`,
    generateDeclaration: `${apiUrl}OfferInfo/declaration/generate`,
    getDeclarationText: `${apiUrl}OfferInfo/declaration/`,
    withdraw: `${apiUrl}OfferInfo/withdraw`,
  };

  public static powerOfAttorneyInfo = {
    info: `${apiUrl}powers-of-attorney/user/info`,
    getPowerOfAttorneyFile: `${apiUrl}powers-of-attorney/{0}/file`,
  };

  public static angularRoutes = {
    positionEditCard: '/supplier/price-lists/positions/edit/',
    positionViewCard: '/supplier/price-lists/positions/',
    participantInfo: '/supplier/price-lists/participant-info',
    positionRegistry: '/supplier/price-lists/positions/registry',
    priceListHistory: '/supplier/price-lists/history',
    positionCreate: '/supplier/price-lists/positions/create',
    priceListEditCard: 'supplier/price-lists/positions/product/',
    priceListOfferItem: 'supplier/price-lists/positions/offer-item/create/',
    priceListDrugOfferItem: 'supplier/price-lists/positions/offer-item-drug/create/',
    priceListOfferEdit: 'supplier/price-lists/offer/edit',
    offersRegistry: 'supplier/price-lists/positions/registry',
    customer: {
      offerRegistry: 'customer/offers/registry',
      offerProductsRegistry: 'customer/offers/registry/products',
      offerDrugsRegistry: 'customer/offers/registry/drugs',
      offerDetails: 'customer/offers/offer-item',
      compareOffer: 'customer/compare-offer',
      compareDrugOffer: 'customer/compare-notification'
    },
  };

  public static fksUrls = {
    applications: `/supplier/auction/Private/Participant.aspx`,
  };

  public static roles = {
    search: `${userSecurityServiceBaseUrl}/customer/roles/search`,
    getRoleInfo: `${userSecurityServiceBaseUrl}/customer/roles/{0}`,
    getRolesShortInfo: `${userSecurityServiceBaseUrl}/customer/roles/short-infos`,
    getPermissionsGroups: `${userSecurityServiceBaseUrl}/customer/permissions/groups`,
    createRole: `${userSecurityServiceBaseUrl}/customer/roles/create`,
    updateRole: `${userSecurityServiceBaseUrl}/customer/roles/update`,
    deleteRole: `${userSecurityServiceBaseUrl}/customer/roles/{0}/delete`,
    forUsersAssignment: `${userSecurityServiceBaseUrl}/customer/roles/for-users-assignment`,
    assignRoles: `${userSecurityServiceBaseUrl}/customer-users/roles/assign`,
    permissions: `${userSecurityServiceBaseUrl}/customer/customer-users/current/permissions/search`,
    permissionsInfo: `${userSecurityServiceBaseUrl}/customer/customer-users/{0}/permissions/info`,
  };

  public static trades = {
    search: `${apiUrl}Trades/offer-price-list-item-creation-data?notificationNumber={0}&starNotificationNumber={1}`,
    registrySearch: `${apiUrl}price-list-items-filter/filter-data-by-notification-number?notificationNumber={0}`,
    registrySearchByOfferItem: `${apiUrl}price-list-items-filter/filter-data-by-offer-item?offerItemId={0}`,
    applicationSearch: `${apiUrl}TradeLotApplications/offer-price-list-item-creation-data?tradeLotApplicationId={0}`,
    drugsNotificationNumberSearch: `${apiUrl}price-list-items-filter/drugs/filter-data-by-notification-number?notificationNumber={0}`,
  };

  public static paymentRequisites = {
    search: `${apiUrl}payment-requisites/search`,
    create: `${apiUrl}payment-requisites`,
    remove: `${apiUrl}payment-requisites/{0}`,
    oktmos: `/common-services/api/v1/Dictionary/oktmos/search`,
    krls: `${apiUrl}Dictionary/krlses/search`,
    krks: `${apiUrl}Dictionary/krkses/search`,
    svr: `${apiUrl}Dictionary/svrs/search`,
    receipt: `${apiUrl}Dictionary/receipt-codes/search`,
    medicalProducts: `${apiUrl}MedicalDevice/search`,
  };

  public static commonServices = {
    employee: {
      getUrl: `${commonServicesBaseUrl}/CustomerEmployees/`,
    },

    organizations: {
      getUrl: `${commonServicesBaseUrl}/Customers/`,
      organizationsShort: `${commonServicesBaseUrl}/Organizations/{id}/short`,
    },
  };

  public static events = {
    url: '/events/hubs/events',
    eventMarkAsRead: '/events/api/v1/user/events/{0}/mark-as-read',
  };

  public static logs = {
    errorUrl: '/common-services/api/v1/client/log/error',
    businessOperationLogUrl: '/supplier/lk/api/extendedbusinesslog',
    customerBusinessOperationLogUrl: '/customer/lk/api/extendedbusinesslog',
  };

  public static offerPriceListItemRegistry = {
    search: `${apiUrl}supplier/offer-price-list-item-registry/search`,
  };

  public static mainMenu = {
    getMenu: `${apiUrl}user-menus/main-menu`,
    getCalendarEventsCount: `/common-services/api/v1/calendar-event/events/to-day`,
    getFilterPublishCount: `/tender/api/v1/Protocol/for-publish/count`,
    getFilterSigningCount: `/tender/api/v1/Protocol/for-signing/count`,
    getClarificationRequestsCount: `/tender/api/v1/customer/clarification-requests/unprocessed/count`,
    getResultClarificationCount: `/tender/api/v1/customer/result-clarification/request/unprocessed/count`,
    getFavoriteTradesCount: '/customer/lk/api/trade/favorite-trades-count',
    regulationsAccept: '/customer/lk/api/customer/reglament/accept',
  };

  public static regulationsUrls = {
    regulationsDocumentUrl: '/customer/lk/Home/GetAnalyticInfoReglament',
    downLoadRegulationsDocumentUrl: '/customer/lk/Home/DownloadAnalyticInfoReglament',
  };

  public static headerUrls = {
    organizationViewUrl: '/customer/lk/OrgInfo',
    employeeViewUrl: '/customer/lk/App/#NotificationSettings',
  };

  public static notifications = {
    sendEmail: `${notificationsApiUrl}etp-debt/send-email`,
  };
}
